/**
 * Created by Ning Jiang on 10/29/2019.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScatterAttentionController} from "@nolimitcity/slot-game/bin/game/reelstoppresentation/scatterattention/ScatterAttentionController";
import {Timeline, TimelineLite} from "gsap";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodScatterSymbol} from "../../symbols/DeadwoodScatterSymbol";
import {DeadwoodScatterAttentionView} from "./DeadwoodScatterAttentionView";

export class DeadwoodScatterAttentionController extends ScatterAttentionController {

    private _view:DeadwoodScatterAttentionView;
    private _gameMode:string;
    private _isPlaying:boolean = false;
    private _allSymbols:DeadwoodScatterSymbol[] = [];

    constructor(index:number) {
        super(index, {
            numOfScattersToWin : 3,
            scattersMap : [false, true, true, true, false]
        });
        this._view = new DeadwoodScatterAttentionView();
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        super.parseFeatureGameData(data);
        this._gameMode = data.mode;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._gameMode === GameMode.FREESPIN || this._gameMode === GameMode.FREESPIN_RESPIN) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        if(this._isPlaying) {
            if(data.reelId === 2 && this._scatterPositions[2] < 0) {
                this.stopAnimation();
            }
            if(data.reelId === 3 && this._scatterPositions[3] < 0) {
                this.stopAnimation();
            }
            // don't return here so the super can dispatch the complete event.
        }
        super.onReelBounce(data);
    }

    private stopAnimation(stopFire:boolean = true):void {
        this._isPlaying = false;
        while(this._allSymbols.length > 0) {
            const scatter:DeadwoodScatterSymbol = this._allSymbols.pop()!;
            if(stopFire) {
                scatter.stopBackFire();
            }
        }
    }

    protected playAttentionAnimation(data:IReelStoppedData):void {
        SlotGame.sound.playEffect((<any>DeadwoodSoundConfig.instance)[`SCATTER_LANDING_${data.reelId}`]);
        this.playSymbolAttentionAnimation(data.reelId, this._scatterPositions[data.reelId]);
        this._view.playAttentionBounce();
        this.dispatchCompleteEvent(data.reelId);
    }

    protected playWinAttentionAnimation(data:IReelStoppedData):void {
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.SCATTER_LANDING_3);
        SlotGame.sound.playAmbience(DeadwoodSoundConfig.instance.FS_INTRO_AMBIANCE);
        this._view.playWinAttentionBounce();
        const timeline:TimelineLite = new TimelineLite({paused : true});
        for(let i:number = 1; i < 4; i++) {
            timeline.add(() => this.playSymbolAttentionAnimation(i, this._scatterPositions[i]), 0);
        }
        timeline.add(() => {
            this.stopAnimation(false);
            this.dispatchCompleteEvent(data.reelId);
        });

        timeline.play();
    }

    private playSymbolAttentionAnimation(reelId:number, symbolId:number):Timeline {
        this._isPlaying = true;
        const scatter:DeadwoodScatterSymbol = <DeadwoodScatterSymbol>Reels.getSymbol(reelId, symbolId);
        if(scatter == null) {
            debugger;
            throw new Error(`DeadwoodScatterAttentionController.playSymbolAttentionAnimation(): Cannot find symbol at reelId = ${reelId}, symbolId = ${symbolId}.`);
        }

        const reelView:PIXI.Container = Reels.getReel(reelId)!.view;
        reelView.parent.addChild(reelView);
        scatter.parent.addChild(scatter);
        this._allSymbols.push(scatter);
        return scatter.changeState({
            state : DeadwoodGameConfig.instance.SYMBOL_STATES.landing,
            replay : true,
            fadeInDuration : 0.5
        })!;
    }
}